(function () {
  const iframe_attrs = {
    scrolling: "no",
    frameBorder: "0",
    id: "a9-iframe"
  };

  const getDataAttr = function (obj, attrName) {
    const data = obj.attributes["data-" + attrName];
    if (typeof data != "undefined") {
      return data.value || undefined;
    }
    return undefined;
  };

  const loadIframe = function () {
    const div = document.getElementById("a9-parent-iframe");
    if (div === null) {
      alert("No div with id a9-parent-iframe is defined");
      return;
    }
    let src = getDataAttr(div, "src");
    if (src === undefined) {
      alert("No data-src defined on div#a9-parent-iframe");
      return;
    }
    const width = getDataAttr(div, "width");
    const iframe = document.createElement("iframe");
    if (src.indexOf("?") === -1) {
      // Add the query string of the parent page if we don't have any in the data-src
      src += document.location.search;
    }
    iframe.setAttribute("src", src + "#" + encodeURIComponent(document.location.href));
    for (const key in iframe_attrs) {
      iframe.setAttribute(key, iframe_attrs[key]);
    }
    if (width !== undefined) {
      iframe.setAttribute("width", width);
    } else {
      iframe.setAttribute("width", "100%");
    }
    div.appendChild(iframe);
  };

  loadIframe();
})();
